module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    key: _vm.fcKey,
    attrs: {
      "persistent": "",
      "max-width": "600px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-icon', _vm._g({
          attrs: {
            "color": "primary",
            "dark": ""
          }
        }, on), [_vm._v("filter_list")])]
      }
    }]),
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Customize " + _vm._s(_vm.widgetTitle))])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', [_vm._v("Chart Types")]), _vm._v(" "), _c('v-radio-group', [_c('v-radio', {
    attrs: {
      "on-icon": "stacked_line_chart",
      "off-icon": "stacked_line_chart",
      "label": "Line",
      "value": "line"
    }
  }, [_vm._v("Test")]), _vm._v(" "), _c('v-radio', {
    attrs: {
      "on-icon": "stacked_bar_chart",
      "off-icon": "stacked_bar_chart",
      "label": "Stacked Column",
      "value": "stackedColumn"
    }
  }, [_vm._v("Test")]), _vm._v(" "), _c('v-radio', {
    attrs: {
      "on-icon": "view_in_ar",
      "off-icon": "view_in_ar",
      "label": "3D Stacked Bar",
      "value": "stackedBar3D"
    }
  }, [_vm._v("Test")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', [_vm._v("Filters")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Show report for the last:")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.options.timeframe.selected),
      callback: function($$v) {
        _vm.$set(_vm.options.timeframe, "selected", $$v)
      },
      expression: "options.timeframe.selected"
    }
  }, _vm._l((_vm.options.timeframe.options), function(option) {
    return _c('v-radio', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Unit of Time:")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.options.timeunit.selected),
      callback: function($$v) {
        _vm.$set(_vm.options.timeunit, "selected", $$v)
      },
      expression: "options.timeunit.selected"
    }
  }, _vm._l((_vm.options.timeunit.options), function(option) {
    return _c('v-radio', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Departments")]), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.options.departments.options,
      "label": "Filter Departments",
      "item-text": "label",
      "item-value": "value",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.options.departments.selected),
      callback: function($$v) {
        _vm.$set(_vm.options.departments, "selected", $$v)
      },
      expression: "options.departments.selected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Regions")]), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.options.regions.options,
      "label": "Filter Regions",
      "item-text": "label",
      "item-value": "value",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.options.regions.selected),
      callback: function($$v) {
        _vm.$set(_vm.options.regions, "selected", $$v)
      },
      expression: "options.regions.selected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Status")]), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.options.statuses.options,
      "label": "Filter Statuses",
      "item-text": "label",
      "item-value": "value",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.options.statuses.selected),
      callback: function($$v) {
        _vm.$set(_vm.options.statuses, "selected", $$v)
      },
      expression: "options.statuses.selected"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', [_vm._v("Reps")]), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.options.reps.options,
      "label": "Filter Reps",
      "item-text": "label",
      "item-value": "value",
      "chips": "",
      "multiple": ""
    },
    model: {
      value: (_vm.options.reps.selected),
      callback: function($$v) {
        _vm.$set(_vm.options.reps, "selected", $$v)
      },
      expression: "options.reps.selected"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}